import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { BsPlusCircle } from 'react-icons/bs';

import NoWorkReports from '../../WorkReports/NoWorkReports';

const NoMonthlyLines = (props) => {
  const {
    setAccordionsSelecteds,
    setShowAddPLToUbicationModal,
    hasPermissionsToAddLines,
    id,
    title,
    buttonLabel
  } = props;

  return (
    <div className=" d-flex flex-sm-column align-items-center">
      <NoWorkReports subtitle="" title={title} />
      <Button
        colorIcon="primary"
        disabled={!hasPermissionsToAddLines}
        fontSizeLabel="15px"
        icon={BsPlusCircle}
        iconRight
        label={buttonLabel}
        onClick={() => {
          setAccordionsSelecteds([id]);
          setShowAddPLToUbicationModal(true);
        }}
        sizeIcon="17px"
        type="button"
        variant="light-gray"
        widthButton="200px"
      />
    </div>
  );
};

NoMonthlyLines.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  hasPermissionsToAddLines: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  setAccordionsSelecteds: PropTypes.func.isRequired,
  setShowAddPLToUbicationModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default NoMonthlyLines;
